import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';


import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';


import { FornecedorListComponent } from './fornecedor-list/fornecedor-list.component';


registerLocaleData(localePT, 'pt', localeExtraPT);

@NgModule({
  providers: [{provide: LOCALE_ID, useValue: 'pt'}],
  declarations: [FornecedorListComponent],
  imports: [
  TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    DialogModule,
    ConfirmDialogModule,
    InputTextModule,
    DialogModule,
    BrowserModule,
    ToastModule
  ],
  exports: [FornecedorListComponent]
})
export class FornecedorModule { }